'use client';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import data from '../../../data/innerpages/portfolio/latestcases';
import mixitup from 'mixitup';

function LatestCases() {
  const mixitupContainerRef = useRef(null);
  const mixerRef = useRef(null);
  const navigate = useNavigate();

  const [typeFilter, setTypeFilter] = useState('*');
  const [statusFilter, setStatusFilter] = useState('*');

  // NAVIGATION
  const handleProjectClick = (project, index) => {
    navigate('/innerpages/project', {
      state: { project, index: project.projectId },
    });
  };

  // INIT MIXITUP
  useEffect(() => {
    if (mixitupContainerRef.current) {
      mixerRef.current = mixitup(mixitupContainerRef.current, {
        animation: { duration: 200 },
        selectors: { target: '.mix-item' },
      });
    }
  }, []);

  // FILTER LOGIC
  useEffect(() => {
    if (mixerRef.current) {
      let filter = '';

      if (typeFilter !== '*') filter += typeFilter;
      if (statusFilter !== '*') filter += statusFilter;

      if (filter === '') filter = '*';

      mixerRef.current.filter(filter);
    }
  }, [typeFilter, statusFilter]);

  return (
    <section style={{ padding: "40px 0", background: "#fff" }}>
      <div style={{ width: "100%", padding: "0 10px" }}>

        {/* TITLE */}
        <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
          Latest Cases
        </h3>

        {/* 🔥 FILTER (CENTER + COMPACT) */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            marginBottom: "25px",
            flexWrap: "wrap",
          }}
        >
          {/* TYPE */}
          <select
            onChange={(e) => setTypeFilter(e.target.value)}
            style={{
              width: "220px",
              padding: "10px",
              border: "1px solid #ccc",
              fontSize: "14px",
              background: "#fff",
              borderRadius: "4px",
              outline: "none",
            }}
          >
            <option value="*">Type of Work</option>
            <option value=".Institutional-Projects">Institutional</option>
            <option value=".Residential-Projects">Residential</option>
            <option value=".Commercial-Projects">Commercial</option>
          </select>

          {/* STATUS */}
          <select
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{
              width: "220px",
              padding: "10px",
              border: "1px solid #ccc",
              fontSize: "14px",
              background: "#fff",
              borderRadius: "4px",
              outline: "none",
            }}
          >
            <option value="*">Status</option>
            <option value=".Completed">Completed</option>
            <option value=".Ongoing">Ongoing</option>
          </select>
        </div>

        {/* 🔥 GRID */}
        <div
          ref={mixitupContainerRef}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            gap: "2px",
          }}
        >
          {data.map((item, i) => (
            <div
              key={i}
              className={`mix-item ${
                item.subTitle
                  ?.replace(/\s+/g, "-")
                  .replace(/[|&]/g, "")
                  .trim()
              } ${item.status?.replace(/\s+/g, "-")}`}
              style={{
                aspectRatio: "1 / 1",
                overflow: "hidden",
                cursor: "pointer",
                position: "relative",
              }}
              onClick={() => handleProjectClick(item, i)}
            >
              {/* IMAGE */}
              <img
                src={item.img}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "0.4s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.08)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />

              {/* OVERLAY */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "rgba(255,255,255,0.9)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: 0,
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = 0)}
              >
                <h3
                  style={{
                    fontFamily: "'Great Vibes', cursive",
                    fontSize: "20px",
                    color: "#000",
                    textAlign: "center",
                  }}
                >
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default LatestCases;
